import Vue from 'vue';
import App from './App.vue';
import store from '@/store/mainStore';
import router from './router';
import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import * as Sentry from '@sentry/vue';

console.warn('%cApplication version ' + (process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : '[DEV]'), 'font-weight: 800; color: #0096D6;');

Vue.config.productionTip = false;

Vue.config.ignoredElements = [/fitstation-\w*/];

// hplog();

Vue.prototype.$state = store;

Object.defineProperty(Vue.prototype, '$engine', {
	get: function $engine() {
		return store.engine;
	}
});

// Vue.use(OverlayScrollbarsPlugin);

// @ts-ignore
window.$state = store;

// @ts-ignore
window.$router = router;

if (window.appConfig.VUE_APP_SENTRY_DSN) {
	// FIXME: in yarn sentry:sourcemaps should add in the build number / version number
	Sentry.init({
		Vue,
		dsn: window.appConfig.VUE_APP_SENTRY_DSN,
		environment: window.appConfig.VUE_APP_SENTRY_ENVIRONMENT || window.appConfig.VUE_APP_STACK || 'unset',
		release: window.appConfig.VUE_APP_SENTRY_RELEASE || 'unset',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true
			})
		],
		// Performance Monitoring
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		tracePropagationTargets: ['localhost', 'clinical', /^https:\/\/.*\.arizeclinical-orthotics\.leopoly\.com/], // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

Vue.use(BootstrapVue, {
	breakpoints: [`xs`, 'sm', 'md', 'lg', 'xl', 'xxl']
});

new Vue({
	router,
	render: (h) => h(App)
}).$mount('#app');
